/**
 * @desc 分页-all
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  defs.appCenter.IPage<defs.appCenter.BizPermissionApplyResponseDto>
>;
export function request(
  params: API.appCenter.bizPermissionApply.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bizPermissionApply/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
